import { TableCell } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import * as R from 'ramda'
import { NumberUtils, Text } from '@pbt/pbt-ui-components'

import type { RetailOrderLineItem } from '~/api/graphql/generated/types'
import { FINANCE_CELL_WIDTH } from '~/constants/financeTable'
import type { InvoiceLineItem } from '~/types'

const { DISCOUNT } = FINANCE_CELL_WIDTH

const useStyles = makeStyles(
  () => ({
    subtotalCell: {
      minWidth: DISCOUNT,
      width: DISCOUNT,
    },
  }),
  { name: 'FinanceItemDiscountCellBody' },
)

export interface FinanceItemDiscountCellBodyProps {
  hidePrices?: boolean
  isFullyRefunded?: boolean
  item: InvoiceLineItem | RetailOrderLineItem
  tableCellClassName: string
  tableCellWithBorder: string
}

const FinanceItemDiscountCellBody = ({
  item,
  tableCellClassName,
  tableCellWithBorder,
  isFullyRefunded = false,
  hidePrices = false,
}: FinanceItemDiscountCellBodyProps) => {
  const classes = useStyles()

  const discountAmount =
    R.prop('discount', item) ?? R.prop('discountAmount', item)

  return (
    <TableCell
      align="right"
      className={classNames(
        tableCellClassName,
        tableCellWithBorder,
        classes.subtotalCell,
      )}
    >
      {!hidePrices && !R.prop('declined', item) && Boolean(discountAmount) && (
        <Text variant={isFullyRefunded ? 'lowAccent2' : 'body2'}>
          {NumberUtils.formatMoney(discountAmount)}
        </Text>
      )}
    </TableCell>
  )
}

export default FinanceItemDiscountCellBody
